import { logUsage } from 'owa-analytics';
import { lazyDidInsertLinksHaveIssuesOnBlockDialogDismiss } from 'owa-mail-compose-actions';

export async function logInsertLinksBlockDialogDatapoint(forceContinue: boolean, isSend: boolean) {
    const didInsertLinksHaveIssuesOnBlockDialogDismiss = await lazyDidInsertLinksHaveIssuesOnBlockDialogDismiss.import();
    const status: boolean = didInsertLinksHaveIssuesOnBlockDialogDismiss();
    logUsage('InsertLinksBlockDialogDismiss', {
        isSend: isSend,
        forceContinue: forceContinue,
        status: status,
    });
}
